// src/components/auth/AuthActionHandler.js
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const AuthActionHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [message, setMessage] = useState("Processing authentication request...");
  
  useEffect(() => {
    // Extract the mode and oobCode parameters
    const queryParams = new URLSearchParams(location.search);
    const mode = queryParams.get("mode");
    const oobCode = queryParams.get("oobCode");
    
    console.log("AuthActionHandler activated with:", { mode, oobCode, fullUrl: window.location.href });
    
    if (!mode || !oobCode) {
      setMessage("Invalid authentication link. Missing parameters.");
      return;
    }
    
    // Redirect based on mode
    if (mode === "resetPassword") {
      console.log("Redirecting to password reset page");
      navigate(`/reset-password?oobCode=${oobCode}`);
    } else if (mode === "verifyEmail") {
      console.log("Redirecting to email verification page");
      navigate(`/verify-email?oobCode=${oobCode}`);
    } else {
      setMessage(`Unknown action mode: ${mode}`);
    }
  }, [location, navigate]);
  
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center',
      height: '100vh',
      textAlign: 'center',
      padding: '20px'
    }}>
      <div>
        <h2>Linkist Authentication</h2>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default AuthActionHandler;